import React from 'react';
import './articleCardSkeleton.css';

/**
 * Skeleton loader component that mimics the shape of an article card.
 * Used during loading states for better perceived performance.
 */
const ArticleCardSkeleton = () => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="article-card-md article-skeleton-card">
        {/* Thumb area skeleton */}
        <div className="article-thumb-skeleton skeleton-shimmer">
          {/* Date badge skeleton */}
          <div className="skeleton-date-badge"></div>
          {/* Title skeleton */}
          <div className="skeleton-title-block"></div>
          {/* Category skeleton */}
          <div className="skeleton-category-block"></div>
        </div>

        {/* Content area skeleton */}
        <div className="article-content">
          {/* Description skeleton */}
          <div className="skeleton-desc-lines">
            <div className="skeleton-line skeleton-shimmer"></div>
            <div className="skeleton-line skeleton-shimmer"></div>
            <div className="skeleton-line skeleton-line-short skeleton-shimmer"></div>
          </div>
          
          {/* Footer skeleton */}
          <div className="skeleton-footer">
            <div className="skeleton-read-more skeleton-shimmer"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCardSkeleton;
